/**
 * @fileoverview Creates a global axios instance for vue and vuex to use
 * @author daisea3e1203
 */

import axios from "axios";
import { baseUrl } from "./config";

const $axios = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

export default $axios;
